<template>
    <div class="block fix-table-for-element-ui">
        <Calendar
            v-model="dateTimeRange"
            dateFormat="dd.mm.yy"
            :numberOfMonths="2"
            selectionMode="range"
            :max-date="getCurrentDate"
            showIcon
            class="ks_filter__calendar"
            ref="calendar"
        >
            <template #footer>
                <Button
                    @click="onLastMonth"
                    :label="$t('lang.main.dateRange.shortcuts.last_month')"
                    class="p-button-link"
                />
                <Button
                    @click="onLastThreeMonth"
                    :label="$t('lang.main.dateRange.shortcuts.last_3_months')"
                    class="p-button-link"
                />
                <Button
                    @click="onLastYear"
                    :label="$t('lang.main.dateRange.shortcuts.last_year')"
                    class="p-button-link"
                />
            </template>
        </Calendar>
    </div>
</template>

<script>
import moment from "moment";
import Button from "primevue/button";
import Calendar from "primevue/calendar";
import {Listeners} from "keysso/constants/listeners";

const RANGE_DELIMITER = '@';

export default {
    name: "UnixDateRange",
    props: {
        item: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            dateTimeRange: null,
        }
    },
    computed: {
        getCurrentDate() {
            return new Date();
        }
    },
    methods: {
        submitFormFilter() {
            this.$emitter.emit(Listeners.KS_FILTER_SUBMIT_FORM);
        },
        /**
         * Парсит строку в массив дат
         * При обновлении страницы в value может попасть строка со значениями через запятую.
         */
        parsePresetValue() {
            let value = this.item.value;

            if (Array.isArray(value) || typeof value !== 'string') {
              return;
            }

            const values = value.split(RANGE_DELIMITER);
            this.dateTimeRange = values.length === 2
                ? values.map(item => new Date(item * 1000))
                : null;
        },
        onLastMonth() {
            const currentDate = new Date();
            this.dateTimeRange = [
              new Date(currentDate.setMonth(currentDate.getMonth() - 1)),
              new Date(),
            ];
            this.onClose();
        },
        onLastThreeMonth() {
            const currentDate = new Date();
            this.dateTimeRange = [
              new Date(currentDate.setMonth(currentDate.getMonth() - 3)),
              new Date(),
            ];
            this.onClose();
        },
        onLastYear() {
            const currentDate = new Date();
            this.dateTimeRange = [
              new Date(currentDate.setFullYear(currentDate.getFullYear() - 1)),
              new Date(),
            ];
            this.onClose();
        },
        onClose() {
            this.$refs.calendar.overlayVisible = false;
        },
    },
    created() {
        this.parsePresetValue();
    },
    components: {
        Button,
        Calendar,
    },
    watch: {
        dateTimeRange(dates) {
            this.dateTimeRange = dates;
            let [start, end] = dates;
            if (!start || !end) {
                return;
            }

            start = moment(start).startOf('day').unix();
            end = moment(end).endOf('day').unix();
            // при выборе одного дня, установка end на начало следующего
            if (end === start) {
                end = moment(end).add( 1, 'd').unix()
            }

            this.item.value = [start, end].join(RANGE_DELIMITER);
        }
    }
}
</script>
